import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from './Extras.page';
import { formWrapper } from '@client/new/pages/challenges/view/Challenges.view.css';
import { ExtrasFormVM } from './viewModel/extrasForm.viewModel';
import { LinkForm } from './components/LinkForm';
import { ContentLegacyGuideForm } from './components/ContentLegacyGuideForm';
import { ExtrasTabModal } from './components/ExtrasTabModal';
import { DeleteContentModal } from './components/DeleteContentModal';

const FormComponents = {
  ContentLink: LinkForm,
  ContentLegacyGuide: ContentLegacyGuideForm,
  ContentTab: ExtrasTabModal,
} as const;

const SideModalForms: (keyof typeof FormComponents)[] = [
  'ContentLink',
  'ContentLegacyGuide',
];

export const ExtrasForms = () => {
  const vm = extrasVM.useValue();

  const type = vm.modalMode.type;
  const FormComponent = FormComponents[vm.formType];
  const isSideModal =
    SideModalForms.includes(vm.formType) &&
    (type === 'edit' || type === 'create');
  const values =
    vm.modalMode.type !== 'none'
      ? (vm.modalMode.value as ExtrasFormVM<typeof vm.formType>).values
      : {};

  return (
    <>
      <DeleteContentModal
        isOpen={type === 'delete'}
        onClose={vm.lazyDispatch('CloseModal')}
        onSubmit={vm.lazyDispatch('ConfirmDelete')}
      />

      <ExtrasTabModal
        isOpen={
          (type === 'edit' || type === 'create') && vm.formType === 'ContentTab'
        }
        onClose={() => vm.dispatch('CloseModal')}
        mode={type as 'edit' | 'create'}
        onSubmit={(data) => vm.dispatch('SaveTab', data)}
        value={(values as any)?.name}
      />

      <SideModal
        isOpen={isSideModal}
        onClose={() => vm.dispatch('CloseModal')}
        noSpacing
      >
        {type !== 'none' && (
          <div className={formWrapper}>
            <FormComponent
              {...(vm.modalMode.value as ExtrasFormVM<
                typeof vm.formType
              > as any)} // TODO: Fix type casting
            />
          </div>
        )}
      </SideModal>
    </>
  );
};
